import { setCookie, getCookie, deleteCookie } from '../parts/cookies-hendler';

/**
 * Shows the popup if `page_show_popup` is set to '1' in the vars_from_php object.
 * Adds the 'active' class to the first element with the 'popup' class, if it exists.
 * 
 * @param {Object} vars_from_php - Object passed from PHP to JavaScript.
 */
const showPopup = (vars_from_php) => {
    if (vars_from_php.page_show_popup === '1' && !getCookie(`hide_popup_on_page_${vars_from_php.page_id}`)) {
        const popup = document.querySelector('.popup');
        if (popup) {
            setTimeout(() => {
                popup.classList.add('active');
            }, 3000);
        }
    }
};

/**
 * Sets a cookie named `hide_popup_on_page_${page_id}` with value 'true'
 * that expires in 1 hour.
 * 
 */
const setPopupHideCookie = () => {
    const cookieName = `hide_popup_on_page_${vars_from_php.page_id}`;
    setCookie(cookieName, true, 1);
};

/**
 * Closes the popup by removing the 'active' class and sets a cookie to hide the popup.
 */
const closePopup = (vars_from_php) => {
    const popup = document.querySelector('.popup');
    if (popup) {
        popup.classList.remove('active');
    }
};

/**
 * Binds click event **only** to `.js-popup-close` elements.
 * Closes the closest parent `.popup` by removing the `active` class.
 */
export const bindPopupClose = () => {
    document.addEventListener('click', (event) => {
        closePopup();
        setPopupHideCookie();
    });
};

/**
 * Binds click events to all `.js-popup-link` elements.
 * - If the link has an href with a hash (e.g. #section-id):
 *     Closes the popup, sets a cookie, and scrolls to the target section.
 * - If the link does not have a hash:
 *     Sets a cookie and proceeds with the default link behavior.
 * 
 * @param {Object} vars_from_php - Object from PHP containing `page_id`
 */
export const bindPopupLinkHandler = (vars_from_php) => {
    const links = document.querySelectorAll('.js-popup-link');
  
    links.forEach((link) => {
        link.addEventListener('click', (event) => {
            const href = link.getAttribute('href');
            const isAnchor = href.startsWith('#');
            const sectionId = href.split('#')[1]; // Extracts the part after '#'
            const targetElement = sectionId ? document.getElementById(sectionId) : null;
    
            // Always set the cookie first
            setPopupHideCookie();
    
            if (isAnchor && targetElement) {
                event.preventDefault(); // Prevent default link behavior
        
                // Close the popup
                closePopup();
        
                // Scroll to the section smoothly
                targetElement.scrollIntoView({ behavior: 'smooth' });
            } else {
                // Proceed with default link behavior (if it's not a section anchor)
                window.location.href = href;
            }
        });
    });
};

/**
 * Initializes popup logic using data from PHP.
 * 
 * @param {Object} vars_from_php - Object passed from PHP to JavaScript.
 */
export const popupHandler = (vars_from_php) => {
    showPopup(vars_from_php);

    bindPopupClose();
};